module.exports = __webpack_public_path__ + "static/media/credit-card_master.a64f6d05.svg";